import { AuthenticatedClientUser } from '@src/authentication/AuthenticatedClientUser';
import type { AuthenticatedUser } from '@src/authentication/AuthenticatedUser';
import { useAuthenticatedUser } from '@src/authentication/useAuthenticatedUser';
import { useAuthentication } from '@src/authentication/useAuthentication';

export const useClientUser = (): AuthenticatedClientUser => {
  const { user } = useAuthentication();

  if (!isClientUser(user)) {
    throw new Error(
      'This hook cannot be rendered outside of Client User context. Please make sure the user logged in is a ClientUser before rendering this.',
    );
  }

  return user;
};

export const useIsClientUser = () => {
  const { user } = useAuthenticatedUser();

  return isClientUser(user);
};

export const isClientUser = (
  user: AuthenticatedUser | AuthenticatedClientUser | null,
): user is AuthenticatedClientUser => {
  return !!user && user instanceof AuthenticatedClientUser;
};
